import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { PatientBox } from "./box";
import { MedicalCards } from "./medical-cards";
import { Profile } from "./profile";
import { useAccountQuery } from "../../graphql";
import { useDashboardTitle } from "../../hooks/useDashboardTitle";
import { getFullName } from "../../utils";

const PatientPage: React.FC = () => {
    const { setTitle } = useDashboardTitle();
    const { clientId } = useParams<{ clientId: string }>();

    const { loading, data } = useAccountQuery({
        variables: {
            id: parseInt(clientId)
        }
    });

    useEffect(() => {
        if (!loading) {
            setTitle(["Llogaritë", getFullName(data.account)]);
        }

    // eslint-disable-next-line
  }, [loading]);

    return <PatientBox clientId={ parseInt(clientId) } />;
};

export default PatientPage;
